export default "__VITE_ASSET__D_jJ2PwJ__"